import React from "react";
import { images } from "../data/images";
type I9LogoProps = {
  size?: "md" | "sm";
};
export function I9Logo({
  size = "md"
}: I9LogoProps) {
  return <img src={images.logo} alt="i9 Sports" className={`w-auto select-none ${size === "md" ? "h-[68px]" : "h-10"}`} draggable={false} data-id="element-49" data-mp="124c7fzx464b5" />;
}